/**
 * The signed-in type scale, each step as size, leading and weight together, so a component that
 * picks a size cannot leave its line height or weight behind:
 *
 *   <h1 {...stylex.props(textStyle.pageTitle)}>
 *
 * `body` and `pageTitle` follow the density theme around them (`compact` or `comfortable` in
 * @lattice/tokens/themes). The `Compact` and `Comfortable` steps hold one density whatever the
 * theme, for the rare element that must not change with it.
 *
 * At most four of these on one screen. A number that lines up with others in a column also takes
 * `fontVariantNumeric: text.numeric`. `metric` sets it already.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
export const textStyle = {
  caption: {
    kGuDYH: "xe2lb4f",
    kLWn49: "x14h5lel",
    k63SB2: "xox936i",
    $$css: true
  },
  label: {
    kGuDYH: "x1awo3zi",
    kLWn49: "x1m9orfk",
    k63SB2: "xqu410z",
    $$css: true
  },
  body: {
    kGuDYH: "xjmaktb",
    kLWn49: "xejwzen",
    k63SB2: "xox936i",
    $$css: true
  },
  bodyCompact: {
    kGuDYH: "x2q0hrr",
    kLWn49: "x1b7t1w1",
    k63SB2: "xox936i",
    $$css: true
  },
  bodyComfortable: {
    kGuDYH: "x1wqujp6",
    kLWn49: "xkmxq6g",
    k63SB2: "xox936i",
    $$css: true
  },
  sectionTitle: {
    kGuDYH: "x1074tzk",
    kLWn49: "xi8kjbl",
    k63SB2: "x117lpx5",
    $$css: true
  },
  pageTitle: {
    kGuDYH: "x17u57ds",
    kLWn49: "x1m48fpm",
    k63SB2: "xqu410z",
    kQqvRs: "x1xwpdav",
    $$css: true
  },
  pageTitleCompact: {
    kGuDYH: "xi6pwt",
    kLWn49: "xju279o",
    k63SB2: "xqu410z",
    $$css: true
  },
  pageTitleComfortable: {
    kGuDYH: "xfv4k1v",
    kLWn49: "xy4x4ie",
    k63SB2: "xqu410z",
    kQqvRs: "x1ntj4s9",
    $$css: true
  },
  metric: {
    kGuDYH: "x1obyofb",
    kLWn49: "x120g7gn",
    k63SB2: "xqu410z",
    kcqcaj: "x1l1vl4p",
    $$css: true
  }
};